import React, {
  useState,
} from 'react';

import {
  Flex,
} from 'web-styled';

import TextField from './TextField';
import * as S from './styled';

export type InputProps = {
  width?: string;
};

const EyeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={16}
    height={16}
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeOffIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={16}
    height={16}
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49" />
    <path d="M14.084 14.158a3 3 0 0 1-4.242-4.242" />
    <path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143" />
    <path d="m2 2 20 20" />
  </svg>
);

const PasswordField = ({ width = '100%', ...rest }: InputProps) => {
  const [visible, setVisible] = useState(false);

  return (
    <Flex width={width}>
      <TextField
        {...rest}
        type={visible ? 'text' : 'password'}
        width={width}
      />
      <S.RightIcon
        top={rest.label ? 42 : 13}
        onClick={() => setVisible(!visible)}
      >
        {visible ? <EyeOffIcon /> : <EyeIcon />}
      </S.RightIcon>
    </Flex>
  );
};

export default PasswordField;
